import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { JqueryUtils } from '../../utils/jquery.utils';
import { InstrumentService } from '../../services/api/instrument.service';

import { NotificationService } from '../../services/notification.service';
import { CONSTANTS } from '../../constants';
import 'rxjs';
import { DataService } from '../../services/data.service';
import { DateUtil } from '../../utils/date.utils';

@Component({
  selector: 'app-entity-instrument',
  templateUrl: './instrument.component.html',
  styleUrls: ['./instrument.component.scss'],
  providers: [
    // { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class InstrumentComponent implements OnInit {

  offset = 0;
  count = 20;
  totalPages = 0;
  totalItems = 0;
  selectedItemPerPage = 0;
  pageNumber = 0;

  instruments: any[] = [];
  instrumentsExpiry: any[] = [];
  modalHeader = '';
  modal_instrument: any = {};
  modal_instrument_expiry: any = {};
  cm_params: any = { };
  admin: any;

  instrument_modal_form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    display_name: new FormControl('', [Validators.required]),
    symbol: new FormControl('', [Validators.required]),
    derivative_name: new FormControl('', [Validators.required]),
    spot_name: new FormControl('', [Validators.required])
  });

  instrument_expiry_modal_form = new FormGroup({
    display_name: new FormControl('', [Validators.required]),
    year: new FormControl('', [Validators.required]),
    month: new FormControl('', [Validators.required]),
    expiry_date: new FormControl('', [Validators.required]),
    expiry_type: new FormControl('', [Validators.required]),
  });

  expiryType = [
    { id: 0, label: "Select" },
    { id: 1, label: "W" },
    { id: 2, label: "M" }
]

  constructor(private instrumentService: InstrumentService, private dataService: DataService,
    private jq: JqueryUtils, private notificationService: NotificationService, private du: DateUtil) { }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.ENTITY_INSTRUMENTS});
    this.listInstruments();
  }

  listInstruments(data = {}) {
    this.instrumentService.listInstruments().subscribe((response: any) => {
      let instruments = response.instruments;
      let instrus = [];
      let instrument;
      for (let idx = 0; idx < instruments.length; idx++) {
        instrument = instruments[idx];
        if (instrument.state == 'active') {
          instrument.state_class = { 'bi-person-check-fill': 1, 'bi-person-fill': 0, 'text-success': 1 }
        } else {
          instrument.state_class = { 'bi-person-check-fill': 0, 'bi-person-fill': 1, 'text-success': 0 }
        }
        instrus.push(instrument);
      }
      this.instruments = instrus;
    });
  }

  listInstrumentsExpiry() {
    let data = { 
      instrument_id: this.modal_instrument_expiry.instrument._id,
      year: this.instrument_expiry_modal_form.value.year,
      month: this.instrument_expiry_modal_form.value.month,
    };
    this.instrumentService.listInstrumentsExpiry(data).subscribe((response: any) => {
      let instruments = response.dates;
      let instrus = [];
      let instrument;
      for (let idx = 0; idx < instruments.length; idx++) {
        instrument = instruments[idx];
        instrus.push(instrument);
      }
      this.instrumentsExpiry = instrus;
    });
  }

  onAddInstrumentExpiry() {
    let data = { 
      instrument_id: this.modal_instrument_expiry.instrument._id,
      year: this.instrument_expiry_modal_form.value.year,
      month: this.instrument_expiry_modal_form.value.month,
      dates: [{
          date: this.instrument_expiry_modal_form.value.expiry_date,
          expiry: this.instrument_expiry_modal_form.value.expiry_type 
        }]
    };
    this.instrumentService.addInstrumentExpiry(data).subscribe((response: any) => {
      if(response.response_code == 1000){
        this.listInstrumentsExpiry()
       /* let instruments = response.dates;
        let instrus = [];
        let instrument;
        for (let idx = 0; idx < instruments.length; idx++) {
          instrument = instruments[idx];
          instrus.push(instrument);
        }
        this.instrumentsExpiry = instrus;*/
      } else {
        this.notificationService.showAlert(CONSTANTS.ERROR, "Expiry Adding failed!");
      }
    });
  }

  onActivate(instrument: any) {
    this.cm_params = {
      msg: `Are you sure want to ${instrument.state == 'active' ? 'deactivate' : 'activate'} this instrument ?`,
      tag: instrument.name,
      btn_text: (instrument.state == 'active') ? 'DEACTIVATE' : 'ACTIVATE',
      btn_class: (instrument.state == 'active') ? {'btn-success': 0, 'btn-danger':1} : {'btn-success': 1, 'btn-danger':0},
      action: 'activate',
      details: {
        _id: instrument._id,
        state: (instrument.state == 'active') ? 0 : 1
      }
    }
    this.jq.openModal('confirmationModal');
  }

  onDeleteExpiryDate(expiry: any){
    if(confirm("Are you sure to delete expiry date")) {
      this.deleteExpiryDate(expiry)
    }
  }

  deleteExpiryDate(expiry: any){
    let toArray =  expiry.date.split("-");
    let data = { 
      instrument_id: this.modal_instrument_expiry.instrument._id,
      year: toArray[0],
      month: toArray[1],
      dates: expiry.date    
    };
    this.instrumentService.deleteInstrumentExpiry(data).subscribe((response: any) => {
      if(response.response_code == 1000){
        this.listInstrumentsExpiry()
      } else {
        this.notificationService.showAlert(CONSTANTS.ERROR, "Expiry deletion failed!");
      }
    });
  }

  deleteAllExpiryDate(){
    if(confirm("Are you sure to delete all expiry dates")) {
      let data = { 
        instrument_id: this.modal_instrument_expiry.instrument._id,
        year: this.instrument_expiry_modal_form.value.year,
        month: this.instrument_expiry_modal_form.value.month,    
      };
      this.instrumentService.deleteInstrumentExpiry(data).subscribe((response: any) => {
        if(response.response_code == 1000) {
          this.listInstrumentsExpiry()
        } else {
          this.notificationService.showAlert(CONSTANTS.ERROR, "Expiry deletion failed!");
        }
      });
    }
  }

  saveInstrument() {
    if (this.modal_instrument.mode == 'add') {
      let data = {
        name: this.instrument_modal_form.value.name,
        display_name: this.instrument_modal_form.value.display_name,
        symbol: this.instrument_modal_form.value.symbol,
        contract_details: {
          derivative_name: this.instrument_modal_form.value.derivative_name,
          spot_name: this.instrument_modal_form.value.spot_name,
        },
        instrument_details: {}
      }
      this.instrumentService.addInstrument(data).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.jq.closeModal('instrumentSaveModal');
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Instrument added successfully")
          this.listInstruments();
        }
      });
    } else if (this.modal_instrument.mode == 'edit') {
      let data = { 
        instrument_id: this.modal_instrument.instrument._id,
        name: this.instrument_modal_form.value.name,
        display_name: this.instrument_modal_form.value.display_name,
        symbol: this.instrument_modal_form.value.symbol,
        contract_details: {
          derivative_name: this.instrument_modal_form.value.derivative_name,
          spot_name: this.instrument_modal_form.value.spot_name,
        },
        instrument_details: {}
      };
      this.instrumentService.updateInstrument(data).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.jq.closeModal('instrumentSaveModal');
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Instrument updated successfully")
          this.listInstruments();
        }
      });
    }
  }

  onAdd() {
    this.modalHeader = 'Add Instrument';
    this.modal_instrument = { header: 'Add Instrument', btn_text: 'ADD', mode: 'add' };
    this.instrument_modal_form.patchValue({
      name: '',
      display_name: '',
      symbol: '',
      derivative_name: '',
      spot_name: ''
    });
    this.jq.openModal('instrumentSaveModal');
  }

  onViewAddInstrumentExpiry(instrument: any) {
    this.modalHeader = 'Add Instrument Expiry';
    this.modal_instrument_expiry = { header: 'Add Instrument Expiry', btn_text: 'ADD', mode: 'add' };
    this.modal_instrument_expiry['instrument'] = instrument;
    let dtarray = this.du.getDate(new Date(),  CONSTANTS.DATE_FORMAT.YYYYMMDD)?.split("-")!;
    this.instrument_expiry_modal_form.patchValue({
      display_name: instrument.display_name,
      year: dtarray[0],
      month: dtarray[1],
    });
    this.listInstrumentsExpiry();
    this.jq.openModal('instrumentExpiryModal');    
  }

  onUpdate(instrument: any) {
    this.modal_instrument['mode'] = 'edit';
    this.modal_instrument['header'] = 'Update Instrument';
    this.modal_instrument['btn_text'] = 'UPDATE';
    this.modal_instrument['instrument'] = instrument;
    this.instrument_modal_form.patchValue({
      name: instrument.name,
      display_name: instrument.display_name,
      symbol: instrument.symbol,
      derivative_name: instrument.contract_details.derivative_name,
      spot_name: instrument.contract_details.spot_name
    });
    this.jq.openModal('instrumentSaveModal');
  }

  onModalClose(modal_name: string) {
    if (modal_name == 'instrument') {
      this.modal_instrument = { header: '', btn_text: '', name: '', email: '', phone: '', subscription_upto: '', password: '' };
      this.jq.closeModal('instrumentSaveModal');
    } else if (modal_name == 'confirmation') {
      this.jq.closeModal('confirmationInstrumentModal');
    } else if (modal_name == 'expiry') {
      this.jq.closeModal('instrumentExpiryModal');
    }
  }

  onViewExpiry(modal_name: string) {
    if(modal_name == 'view'){
      this.listInstrumentsExpiry();
    } else if(modal_name == 'add'){
      this.onAddInstrumentExpiry();
    }
  }

  onConfirm() {
    if (this.cm_params.action == 'activate') {
      let input = { "_id": this.cm_params.details._id, "state": this.cm_params.details.state };
      this.instrumentService.activateInstrument(input).subscribe((response: any) => {
        if (this.cm_params.details.state == 1) {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Instrument Activated successfully");
        } else {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Instrument Deactivated successfully");
        }
        this.cm_params = { };
        this.jq.closeModal('confirmationInstrumentModal');
        this.listInstruments();
      });
    }
  }

  get name() {
    return this.instrument_modal_form.get('name') as FormControl
  }

  get name_errors() {
    return (this.instrument_modal_form.get('name') as FormControl).errors as ValidationErrors
  }

  get display_name() {
    return this.instrument_modal_form.get('display_name') as FormControl
  }

  get display_name_errors() {
    return (this.instrument_modal_form.get('display_name') as FormControl).errors as ValidationErrors 
  }

  get symbol() {
    return this.instrument_modal_form.get('symbol') as FormControl
  }

  get symbol_errors() {
    return (this.instrument_modal_form.get('symbol') as FormControl).errors as ValidationErrors
  }

  get derivative_name() {
    return this.instrument_modal_form.get('derivative_name') as FormControl
  }

  get derivative_name_errors() {
    return (this.instrument_modal_form.get('derivative_name') as FormControl).errors as ValidationErrors
  }

  get spot_name() {
    return this.instrument_modal_form.get('spot_name') as FormControl
  }

  get spot_name_errors() {
    return (this.instrument_modal_form.get('spot_name') as FormControl).errors as ValidationErrors
  }

  get year() {
    return this.instrument_expiry_modal_form.get('year') as FormControl
  }

  get year_errors() {
    return (this.instrument_expiry_modal_form.get('year') as FormControl).errors as ValidationErrors
  }

  get month() {
    return this.instrument_expiry_modal_form.get('month') as FormControl
  }

  get month_errors() {
    return (this.instrument_expiry_modal_form.get('month') as FormControl).errors as ValidationErrors
  }

  get expiry_date() {
    return this.instrument_expiry_modal_form.get('expiry_date') as FormControl
  }

  get expiry_date_errors() {
    return (this.instrument_expiry_modal_form.get('expiry_date') as FormControl).errors as ValidationErrors
  }

  get expiry_type() {
    return this.instrument_expiry_modal_form.get('expiry_type') as FormControl
  }

  get expiry_type_errors() {
    return (this.instrument_expiry_modal_form.get('expiry_type') as FormControl).errors as ValidationErrors
  }

  next() { }
  prev() { }
}
